import { message } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import {
  queryPortletTypes,
  queryPortals,
  queryPortlets,
  queryPortalsPortlets,
  savePortlets,
  bindPortlets,
  queryMenus,
} from '@pages/PortletMgr/services/portlet';
import { cloneDeep } from 'lodash';

const generatePortletsData = (parent, children) => {
  const parents = parent.map(item => {
    const etem = item;
    etem.portletName = etem.typeName;
    etem.key = `portlet_type_${etem.typeId}`;
    etem.children = [];
    children.forEach((child, index) => {
      if (child.typeId === etem.typeId) {
        // eslint-disable-next-line no-param-reassign
        child.key = `portlet_${index}`;
        etem.children.push(child);
      }
    });
    return etem;
  });
  return parents;
};

const generatePortalsPortletsData = (parent, children) => {
  const parents = parent.map(item => {
    const etem = item;
    etem.name = item.portalName;
    etem.key = `portal_${item.portalId}`;
    etem.children = [];
    children.forEach((child, index) => {
      if (child.portalId === item.portalId && child.state === 'A') {
        // eslint-disable-next-line no-param-reassign
        child.name = child.portletName;
        // eslint-disable-next-line no-param-reassign
        child.key = `${item.portalId}_portlet_${index}`;
        item.children.push(child);
      }
    });
    return etem;
  });
  return parents;
};

const generateMenusPortletsData = (parent, children) => {
  const parents = parent.map(item => {
    const etem = item;
    etem.name = item.privName;
    etem.key = `menu_${item.privId}`;
    etem.children = [];
    children.forEach((child, index) => {
      if (child.menuId === item.privId && child.state === 'A') {
        // eslint-disable-next-line no-param-reassign
        child.name = child.portletName;
        // eslint-disable-next-line no-param-reassign
        child.key = `${item.privId}_portlet_${index}`;
        item.children.push(child);
      }
    });
    return etem;
  });
  return parents;
};

export default {
  namespace: 'portletMgr',

  state: {
    portals: [],
    portlets: [],
    portletTypes: [],
    portletInfo: {},
    selectInfo: {},
    showPortletModal: false,
    menus: [],
    dataList: [], // 右侧tab表格数据
  },

  effects: {
    *qryPortletTypes(_, { call, put }) {
      const { success, data } = yield call(queryPortletTypes);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            portletTypes: data,
          },
        });
      }
    },
    *qryPortlets(_, { call, put, select }) {
      const { success, data } = yield call(queryPortlets);
      if (success) {
        const { portletTypes } = yield select(state => state.portletMgr);
        const res = generatePortletsData(cloneDeep(portletTypes), data);
        yield put({
          type: 'save',
          payload: {
            portlets: res,
          },
        });
        return res;
      }
      return null;
    },
    *qryPortals(_, { call, put }) {
      const { success, data } = yield call(queryPortals);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            portals: data,
          },
        });
      }
    },
    *qryPortalsPortlets(_, { call, put, select }) {
      const { success, data } = yield call(queryPortalsPortlets);
      if (success) {
        const { portals } = yield select(state => state.portletMgr);
        const res = generatePortalsPortletsData(JSON.parse(JSON.stringify(portals)), data);
        yield put({
          type: 'save',
          payload: {
            dataList: res,
          },
        });
      }
    },
    *savePortlets({ payload }, { call }) {
      const { success, data } = yield call(savePortlets, payload);
      if (success) {
        if (data === 'success') {
          message.success(i18n('PORTLETMGR_MODIFY_PORTLET_SUCCESS'));
        } else {
          message.success(i18n('PORTLETMGR_ADD_PORTLET_SUCCESS'));
        }
      }
    },
    *bindPortlets({ payload }, { call }) {
      const { success } = yield call(bindPortlets, payload);
      if (success) {
        message.success(i18n('PORTLETMGR_BIND_PORTLET_SUCCESS'));
      }
    },
    *queryMenus(_, { call, put }) {
      const { success, data } = yield call(queryMenus);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            menus: data,
          },
        });
      }
    },
    *qryMenusPortlets(_, { call, put, select }) {
      const { success, data } = yield call(queryPortalsPortlets);
      if (success) {
        const { menus } = yield select(state => state.portletMgr);
        const res = generateMenusPortletsData(JSON.parse(JSON.stringify(menus)), data);
        yield put({
          type: 'save',
          payload: {
            dataList: res,
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
